import React from 'react';
import { motion } from 'framer-motion';
import { Quote, Star } from 'lucide-react';
import { Translations } from '../types';
import SpotlightCard from './SpotlightCard';

interface SocialProofProps {
  t: Translations;
}

export const SocialProof: React.FC<SocialProofProps> = ({ t }) => {
  return (
    <section className="social-proof" id="community">
      <div className="container">
        <motion.div
          className="social-header"
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
          viewport={{ once: true }}
        >
          <h2 className="social-title">{t.social.title}</h2>
          <p className="social-subtitle">{t.social.subtitle}</p>
        </motion.div>

        <div className="testimonials-container">
          {/* All testimonials */}
          {t.social.testimonials.map((testimonial, index) => (
            <motion.div
              key={index}
              initial={{ opacity: 0, y: 50 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.8, delay: 0.2 + index * 0.2 }}
              viewport={{ once: true }}
            >
              <SpotlightCard 
                className={`testimonial-card ${index === 0 ? 'main-testimonial' : 'small-testimonial'}`}
                spotlightColor={index === 0 ? "rgba(0, 255, 157, 0.08)" : "rgba(0, 255, 157, 0.1)"}
              >
                <div className="testimonial-content">
                  <Quote className="quote-icon" />
                  <p className="testimonial-text">
                    "{testimonial.text}"
                  </p>
                  <div className="testimonial-footer">
                    <span className="testimonial-role">
                      {testimonial.role}
                    </span>
                  </div>
                  <div className="rating">
                    {[...Array(5)].map((_, i) => (
                      <Star key={i} className="star filled" size={20} />
                    ))}
                  </div>
                </div>
              </SpotlightCard>
            </motion.div>
          ))}
        </div>

        <motion.div
          className="trust-logos"
          initial={{ opacity: 0 }}
          whileInView={{ opacity: 1 }}
          transition={{ duration: 0.8, delay: 0.4 }}
          viewport={{ once: true }}
        >

        </motion.div>
      </div>
    </section>
  );
}; 
